
        //bootstrp modal z-index problem fix
        (function($) {
            $(document).on('show.bs.modal', '.modal', function () {
                $(this).appendTo('body');
            });
        })(jQuery);
    